<template>
  <div class="landingContainer">
    <slot />
  </div>
</template>

<script>
export default {
  name: "LandingContainer",
};
</script>

<style lang="scss" scoped>
.landingContainer {
  margin: 0 auto;
  max-width: $container-world-lg;
  padding: 0 16px;

  @media (min-width: $breakpoint-md) {
    padding: 0 32px;
  }

  @media (min-width: $breakpoint-xl) {
    padding: 0 16px;
  }
}
</style>
